export default __webpack_public_path__ + "static/media/back2.b781ad53.png";